import React from 'react';
import { SearchInput } from '../../../../components/search-input/search-input';
import './SpeakerHeader.scss';

interface IProps {
  label: string;
  handleSearch: (value: string) => void;
}

const SpeakerHeader: React.FC<IProps> = (props: IProps): JSX.Element => {
  const { label, handleSearch } = props;

  return (
    <>
      <div className='speaker-header'>
        <h1 className={`speaker-title font-size-40px`}>{label}</h1>
        <SearchInput
          onChange={handleSearch}
          withDebounce
          withResetSearchButton
        />
      </div>
      <hr/>
    </>
  );
};

export default SpeakerHeader;
